import styled from '@emotion/styled'
import { css } from '@emotion/react'

const iconStyles = ({ theme }) => css`
  label: icon;

  width: 22px;
  height: 22px;

  margin-right: ${theme.spacings.bit};
`

const Icon = styled('svg')(iconStyles)

export default Icon
